import { render, staticRenderFns } from "./DropZone.vue?vue&type=template&id=14e9a745&scoped=true&"
import script from "./DropZone.vue?vue&type=script&lang=js&"
export * from "./DropZone.vue?vue&type=script&lang=js&"
import style0 from "./DropZone.vue?vue&type=style&index=0&id=14e9a745&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e9a745",
  null
  
)

export default component.exports